import Collapse, { CollapseItem } from './Collapse';

export default Collapse;
export { CollapseItem };
